import app from '@/main';
import graphql from '@/graphql';

/**
 * Makes a GraphQL request
 * @param { query, params } - The query to make, with the params to process
 * @param sessionExpiredMessage
 * @returns Promise - The result of the request
 */
const graphqlHelper = async ({ query, variables }, sessionExpiredMessage = undefined) => {
  const token = app.$auth0.getIdToken() || (await app.$auth.getIdToken());
  return graphql.apolloFetch(
    token,
    {
      query,
      variables,
    },
    sessionExpiredMessage
  );
};

export default graphqlHelper;



// WEBPACK FOOTER //
// ./src/services/graphqlHelper.js